import React from 'react';
import { connect } from 'react-redux';
import { selectConsultationMover } from '../../../redux/actions/consultations';

const mapStateToProps = ({ consultations }, ownProps) => ({
	movers: consultations.options[ownProps.index].movers,
});

export const ConsultationMovers = ({
	movers,
	index,
	selectConsultationMover,
	options,
	setFieldValue,
}) => {
	const handleSelectMover = (index, mover) => {
		setFieldValue('mover_selected', true);
		selectConsultationMover(index, mover);
	};
	return (
		!!movers && (
			<div className="container">
				<ul className="row mt-4">
					{movers.map((mover, i) => {
						let isSelected =
							options[index].mover === undefined
								? false
								: options[index].mover.id === mover.id;
						let isDisabled =
							!isSelected &&
							!!options
								.map(option =>
									option.mover === undefined ? undefined : option.mover.id
								)
								.includes(mover.id);
						return (
							<li
								key={i}
								style={{ height: '70px', padding: '10px', cursor: 'pointer' }}
								className={`consultation-mover-option col-sm-12 col-md-6 ${
									isDisabled && 'disabled'
								}`}
								onClick={() =>
									isDisabled ? null : selectConsultationMover(index, mover)
								}>
								<div className="d-inline-block">
									<input
										disabled={isDisabled}
										type="radio"
										checked={isSelected}
										onChange={() => handleSelectMover(index, mover)}
										name="mover{{$parent.$index}}"
										id="mover{{$index}}{{$parent.$index}}"
									/>
								</div>
								<div className="logo-wrapper d-inline-block ml-3">
									{/* src={mover.logo_url} */}
									<img
										style={{ maxHeight: '50px' }}
										src={mover.logo_url}
										height="50"
										alt="mover logo"
									/>
								</div>
								<label
									style={{ cursor: 'pointer' }}
									className="mover-name d-inline-block ml-2">
									{mover.name}
								</label>
							</li>
						);
					})}
				</ul>
				<style jsx>{`
					.consultation-mover-option {
					}
					.disabled {
						opacity: 0.3;
					}
				`}</style>
			</div>
		)
	);
};

export default connect(mapStateToProps, { selectConsultationMover })(
	ConsultationMovers
);
